<div class="data-orderline" [ngClass]="{'is-in-cart': isInCart }">

  <div class="column column-width-10">
    <div class="image" [ngStyle]="{'background-image': 'url(' + thumbnail + '), url(\'/assets/images/no-image-placeholder.png\')'}">
      <div class="content"></div>
    </div>
  </div>

  <div class="column column-width-30">
    <h3>{{ line.productName }}</h3>
    <!-- <span class="fields" *ngIf="hasDesc">{{ line.productDesc }}</span> -->
    <span class="fields productnumber">{{ line.productCode }}</span>
  </div>

  <div class="column column-width-10">
    <span class="fields">{{ relativeQuantity }}</span>
  </div>

  <div class="column column-width-10">
    <span class="fields">{{ line.stepping }}</span>
  </div>

  <div class="column column-width-10">
    <span class="fields">{{ absoluteQuantity }}</span>
  </div>

  <div class="column column-width-10">
    <span class="fields">{{ line.itemprice | price: currency }}</span>
  </div>

  <div class="column column-width-10">
    <span class="fields">{{ line.lineprice | price: currency }}</span>
  </div>

  <div class="column column-width-10">
      <button *ngIf="isProductOrderable" (click)="reOrder()" class="btn btn-success">{{ 'order.reorder' | translate }}</button>
      <span *ngIf="!isProductOrderable">{{ 'product.notAvailable' | translate }}</span>
  </div>
</div>
